import React from "react";

export const YellowArrow = ({ style }: { style?: React.CSSProperties }) => (
  <svg
    width="146"
    style={style}
    height="213"
    viewBox="0 0 146 213"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M194.116 136.48C196.69 131.097 188.79 101.592 185.28 103.448C182.911 104.735 181.357 108.155 181.599 111.679C181.725 114.267 188.876 140.122 189.539 140.513C190.623 141.18 192.829 139.171 194.116 136.48ZM171.041 70.6661C162.228 53.8271 156.974 50.4803 155.091 60.7482C154.474 64.2869 163.053 80.7271 168.936 89.0011C175.012 97.6076 181.726 91.1502 171.041 70.6661ZM142.087 43.2668C144.758 36.7156 135.029 27.2037 122.732 24.268C109.217 21.0306 96.8107 24.4299 95.0125 31.8789C93.9164 36.3781 94.5942 36.9438 100.444 36.1224C114.299 34.1621 124.777 37.1004 134.071 45.4255C136.876 47.9952 140.626 46.9939 142.087 43.2668ZM70.0659 90.6126C70.6799 88.5497 70.5626 88.3508 67.4945 85.0342C65.7737 83.1308 61.1247 78.0016 61.1247 78.0016L68.7769 68.2549C76.4285 58.5087 84.9065 49.1389 87.8468 47.1985C90.9748 45.1342 87.9338 43.6407 80.1888 43.5946C74.0602 43.4949 61.9815 56.347 54.3495 70.8691C54.0671 71.4238 46.2156 64.0807 44.5118 61.6135C41.5554 57.3022 32.3741 60.1379 33.0501 74.3346C33.3906 82.0299 28.5816 104.635 25.5174 109.328C21.4658 115.593 26.3351 116.801 33.2033 111.348C44.0298 102.73 68.2865 96.7599 70.0659 90.6126Z"
      fill="#FFD100"
    />
  </svg>
);
